
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offer-page",
      function () {
        return require("private-next-pages/offer-page/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offer-page"])
      });
    }
  